<template>
  <div class="shipmentInspect-preview">
    <div class="title">{{shipmentInspectVo.billNo}}</div>
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="shipmentInspectVo"
        class="form"
        label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="系统编号">
            <span>{{shipmentInspectVo.billNo}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="登记人">
            <span>{{shipmentInspectVo.creatorName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发货单">
            <span>{{shipmentInspectVo.deliveryBillNo}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="异常/不良描述">
            <span>{{shipmentInspectVo.processDesc}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称">
            <span>{{shipmentInspectVo.customerName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应商名称">
            <span>{{shipmentInspectVo.supplierName}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="检验数量">
            <span>{{shipmentInspectVo.qualifiedQuantity}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="异常/不良数量">
            <span>{{shipmentInspectVo.badQuantity}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="库存数量">
            <span>{{shipmentInspectVo.stockQuantity}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否已质检：">
            <span>{{shipmentInspectVo.isInspection ? '是' : '否'}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="检验结果：">
            <span>{{shipmentInspectVo.inspectionResult ? 'OK' : 'NG'}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="责任部门">
            <span>{{shipmentInspectVo.responsibilityDepartment}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否处理：">
            <span>{{shipmentInspectVo.needHandle ? '是' : '否'}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="区域负责工程师：">
            <span>{{shipmentInspectVo.regionalManager}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item v-if="shipmentInspectVo.needHandle" label="处理人：">
            <span>{{shipmentInspectVo.handleName}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="发货备注">
            <span>{{shipmentInspectVo.deliveryNote}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="处理方式">
            <span>{{shipmentInspectVo.handleWay}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="table-box">
        <h3 class="box-title">配货明细</h3>
        <el-table
            :data="shipmentInspectVo.shipmentInspectMaterialDetails"
            border
            stripe
            style="width: 100%">
          <el-table-column
              prop="materialNo"
              label="物料编号"
              min-width="120"/>
          <el-table-column
              prop="specification"
              align="center"
              label="规格型号"
              show-overflow-tooltip/>
          <el-table-column
              prop="barcodeRecord"
              align="center"
              label="条码"
              show-overflow-tooltip/>
          <el-table-column
              prop="materialName"
              align="center"
              label="物料描述"
              show-overflow-tooltip/>
          <el-table-column prop="unit" align="center" label="单位" width="100"/>
          <el-table-column prop="quantity" align="center" label="数量" width="100"/>
        </el-table>
      </div>
      <div class="table-box">
        <h3 class="box-title">性能检查</h3>
        <el-table :data="shipmentInspectVo.inspectionItems" border stripe style="width: 100%">
          <el-table-column type="index" width="50" label="序号" align="center"/>
          <el-table-column prop="name" label="工序名称" min-width="150"/>
          <el-table-column prop="inspectionStandard" label="检验标准" min-width="200"/>
          <el-table-column prop="approver" label="检验结果" min-width="100">
            <template slot-scope="scope">
              <span>{{approverMap[scope.row.approver] || ''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="inspectionMethod" label="检验方式" min-width="100">
            <template slot-scope="scope">
              <span>{{inspectionMethodMap[scope.row.inspectionMethod] || ''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="inspectionFrequency" label="检验频次" min-width="100">
            <template slot-scope="scope">
              <span>{{inspectionFrequencyMap[scope.row.inspectionFrequency] || ''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="note" label="备注" min-width="100"/>
        </el-table>
      </div>
      <div class="table-box">
        <h3 class="box-title">包装检查</h3>
        <el-table :data="shipmentInspectVo.inspectionItemsBZ" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" align="center"/>
          <el-table-column prop="name" label="工序名称" min-width="150"/>
          <el-table-column prop="inspectionStandard" label="检验标准" min-width="200"/>
          <el-table-column prop="approver" label="检验结果" min-width="100">
            <template slot-scope="scope">
              <span>{{approverMap[scope.row.approver] || ''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="inspectionMethod" label="检验方式" min-width="100">
            <template slot-scope="scope">
              <span>{{inspectionMethodMap[scope.row.inspectionMethod] || ''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="inspectionFrequency" label="检验频次" min-width="100">
            <template slot-scope="scope">
              <span>{{inspectionFrequencyMap[scope.row.inspectionFrequency] || ''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100"/>
        </el-table>
      </div>
      <div class="table-box">
        <h3 class="box-title">附件信息</h3>
        <el-table
            v-if="shipmentInspectVo.attachments && shipmentInspectVo.attachments.length > 0"
            :data="shipmentInspectVo.attachments">
          <el-table-column type="index" align="center" label="行号" width="60"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述"/>
        </el-table>
        <div v-else style="text-align: center; color: #999; padding: 20px;">
          暂无附件
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
  const inspectionMethodMap = {
    1: "目测",
    2: "驱动器、电机、线材",
    3: "其他",
  };
  const inspectionFrequencyMap = {
    1: "每/单",
    2: "按照抽样方案GB2828-I",
    3: "其他",
  };
  const approverMap = {
    0: "NG",
    1: "OK",
    2: "NA",
  };
  export default {
    name: "ShipmentInspectPreview",
    data() {
      return {
        inspectionMethodMap,
        inspectionFrequencyMap,
        approverMap,
        contentLoading: false,
        imgUrls: [],
        shipmentInspectVo: {
          pkid: "",
          billNo: "",
          creatTime: "",
          creatorName: "",
          supplierName: "",
          customerName: "",
          customerId: "",
          supplierId: "",
          supplierCode: "",
          processNode: "",
          processDesc: "",
          materialNo: "",
          materialName: "",
          quantity: "",
          isInspection: false,
          inspectionResult: true,
          needHandle: true,
          qualifiedQuantity: "",
          badQuantity: "",
          stockQuantity: "",
          responsibilityDepartment: "",
          handleName: "",
          regionalID: "",
          handleID: "",
          handleWay: "",
          deliveryBillNo: "",
          deliveryNote: "",
          barcodeRecord: "",
          regionalManager: "",
          attachments: [],
          inspectionItems: [],
          inspectionItemsBZ: [],
          shipmentInspectMaterialDetails: [],
        },
      };
    },
    created() {
      if (this.$route.query.billId) {
        this.shipmentInspectVo.pkid = this.$route.query.billId;
        this.getData();
      }
    },
    methods: {
      getData() {
        this.contentLoading = true;
        this.$http.get("basic", `shipmentInspects/${this.shipmentInspectVo.pkid}`).then((res) => {
          this.contentLoading = false;
          if (res.success) {
            this.shipmentInspectVo = res.data;
            // 处理附件URL
            this.shipmentInspectVo.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });

            });
          } else {
            this.$message.error(res.message);
          }
        }).catch(() => {
          this.contentLoading = false;
        });
      },
      downloadFile(row) {
        window.open(row.fileUrl);
      },
    },
  };
</script>

<style scoped>
.shipmentInspect-preview {
  padding: 20px;
  background-color: #fff;
  min-height: 100vh;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
}

.form {
  width: 100%;
}

.vm-separate {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.table-box {
  margin-top: 30px;
}

.box-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  padding-left: 5px;
  border-left: 3px solid #409EFF;
}

.images {
  margin-top: 15px;
}

.file-download {
  color: #409EFF;
  cursor: pointer;
}

.file-download:hover {
  text-decoration: underline;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #999;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
</style>